import * as React from 'react';
import {
  Wrapper,
  Button,
  LabelWrapper,
  Label,
  NotificationWrapper,
  NotificationNumber,
} from './elements';

type TabMe03Props = {
  readonly className?: string;
  readonly tabs: { icon: string; label: string; notifications?: number }[];
  readonly selected: number;
  readonly disabled?: number[];
  readonly alignment: 'left' | 'center' | 'split';
  readonly changeTab: (index: number) => void;
};

export default function TabMen03({
  className,
  tabs,
  selected,
  disabled = [],
  alignment,
  changeTab,
}: TabMe03Props): React.ReactElement {
  const augmentedTabs = tabs.map(({ icon, label, notifications }, index) => ({
    icon,
    label,
    notifications: notifications || 0,
    index,
    isSelected: selected === index,
    isDisabled: disabled.includes(index),
    shouldSplit: tabs.length - 1 === index && alignment === 'split',
  }));

  return (
    <Wrapper className={className} $center={alignment === 'center'}>
      {augmentedTabs.map(
        ({
          icon,
          label,
          index,
          notifications,
          isSelected,
          isDisabled,
          shouldSplit,
        }) => (
          <Button
            $split={shouldSplit}
            disabled={isDisabled}
            key={label}
            onClick={() => changeTab(index)}
          >
            {notifications !== 0 && (
              <NotificationWrapper>
                <NotificationNumber>{notifications}</NotificationNumber>
              </NotificationWrapper>
            )}
            <LabelWrapper
              disabled={isDisabled}
              $selected={isSelected}
              $split={shouldSplit}
            >
              <Label disabled={isDisabled} $selected={isSelected} icon={icon}>
                {label}
              </Label>
            </LabelWrapper>
          </Button>
        )
      )}
    </Wrapper>
  );
}
